import { createSlice } from '@reduxjs/toolkit'
const now = new Date().getTime();
const initialState = {
  isWaiting: false,
  shortName: "",
  byId: {},
  allIds: [],
  oldestCallTime: now,
  newestCallTime: now,
  filterType: 0,
  filterTalkgroups: [],
  filterGroupId: false,
  filterUnit: "",
  // Stacked, SIEM-style condition rows. When non-empty this is the active
  // filter and the legacy filterType/* fields above are ignored (kept only so
  // the simple tabs and old shared URLs still work). See backend/filter.js.
  filterRows: [],
  // Optional From/To range (ms epoch, or false) that pairs with the advanced
  // filter and bounds the calls shown. Part of the same advanced-filter spec.
  filterTimeframe: { from: false, to: false },
  filterDate: false,
  filterStarred: false,
  filterCallId: false,
  currentCallId: false,
  playlist: [],
  live: false,
  centerCall: true,
  backgroundAutoplay: false,
  showTranscripts: true
}

const compareCalls = (a, b) => {
  const aTimestamp = new Date(a.time).getTime()
  const bTimestamp = new Date(b.time).getTime()
  if (aTimestamp > bTimestamp) {
    return -1
  } else {
    return 1
  }
}

export const callPlayerSlice = createSlice({
  name: 'callPlayer',
  initialState,
  reducers: {
    setCurrentCallId: (state, action) => {
      state.currentCallId = action.payload;
    },
    setFilterCallId: (state, action) => {
      state.filterCallId = action.payload;
    },
    setCallTime: (state, action) => {
      state.newestCallTime = action.payload;
      state.oldestCallTime = action.payload;
    },
    setPlaylist: (state, action) => {
      if (Array.isArray(action.payload )) {
      state.playlist = action.payload;
      }
    },
    removeFromPlaylist: (state, action) => { 
      const call = action.payload;
      if (call) {
        const found = state.playlist.findIndex(c => c._id == call._id);
        if (found != -1) {
          state.playlist.splice(found, 1)
        }
      }
    },
    addToPlaylist: (state, action) => {
      const call = action.payload;
      const found = state.playlist.find(c => c._id == call._id);
      if (!found) {
        const newlist = [...state.playlist, call];
        state.playlist = newlist.sort(compareCalls);
      }
    },
    setFilter: (state,action) => {
      var filter={};
      state.live = !action.payload.live ? state.live : action.payload.live;
      state.filterStarred = !action.payload.filterStarred ? false : action.payload.filterStarred;
      state.filterType = !action.payload.filterType ? 0 : action.payload.filterType;
      state.filterTalkgroups = !action.payload.filterTalkgroups ? [] : action.payload.filterTalkgroups;
      state.filterGroupId = !action.payload.filterGroupId ? false : action.payload.filterGroupId;
      state.filterUnit = !action.payload.filterUnit ? "" : action.payload.filterUnit;
      state.filterDate = !action.payload.filterDate ? 0 : action.payload.filterDate;
      state.filterCallId = !action.payload.filterCallId ? false : action.payload.filterCallId;
      state.filterRows = !action.payload.filterRows ? [] : action.payload.filterRows;
      state.filterTimeframe = !action.payload.filterTimeframe ? { from: false, to: false } : action.payload.filterTimeframe;
      state.shortName = !action.payload.shortName ? state.shortName : action.payload.shortName;
    },
    setLive: (state,action) => {
      state.live = action.payload;
    },
    setCenterCall: (state,action) => {
      state.centerCall = action.payload;
    },
    setBackgroundAutoplay: (state,action) => {
      state.backgroundAutoplay = action.payload;
    },
    setShowTranscripts: (state,action) => {
      state.showTranscripts = action.payload;
    },
    setShortName: (state, action) => {
      state.shortName = action.payload;
    },
    setDateFilter: (state, action) => {
      state.filterDate = action.payload;
    },
    setStarredFilter: (state, action) => {
      state.filterStarred = action.payload;
    },
    setAllFilter: (state) => {
      state.filterType = 0;
      state.filterTalkgroups = [];
      state.filterGroupId = 0;
      state.filterUnit = "";
      state.filterRows = [];
      state.filterTimeframe = { from: false, to: false };
    },
    setGroupFilter: (state, action) => {
      state.filterType = 1;
      state.filterTalkgroups = [];
      state.filterGroupId = action.payload;
      state.filterUnit = "";
      state.filterRows = [];
      state.filterTimeframe = { from: false, to: false };
    },
    setTalkgroupFilter: (state, action) => {
      state.filterType = 2;
      state.filterTalkgroups = action.payload;
      state.filterGroupId = 0;
      state.filterUnit = "";
      state.filterRows = [];
      state.filterTimeframe = { from: false, to: false };
    },
    setUnitFilter: (state, action) => {
      state.filterType = 3;
      state.filterUnit = action.payload;
      state.filterTalkgroups = [];
      state.filterGroupId = 0;
      state.filterRows = [];
      state.filterTimeframe = { from: false, to: false };
    },
    // The advanced stacked filter. When set it supersedes the legacy single
    // filter, so clear those fields to keep the two from fighting. The timeframe
    // is a sibling part of the advanced filter, so it is left untouched here.
    setFilterRows: (state, action) => {
      const rows = Array.isArray(action.payload) ? action.payload : [];
      state.filterRows = rows;
      state.filterType = 0;
      state.filterTalkgroups = [];
      state.filterGroupId = 0;
      state.filterUnit = "";
    },
    // The From/To range paired with the advanced filter.
    setFilterTimeframe: (state, action) => {
      const tf = action.payload || {};
      state.filterTimeframe = { from: tf.from || false, to: tf.to || false };
    },

  },
})

// Action creators are generated for each case reducer function
export const { setCurrentCallId, setCallTime, setFilter, setLive, setCenterCall, setBackgroundAutoplay, setShowTranscripts, setPlaylist, removeFromPlaylist, addToPlaylist, setShortName, setDateFilter, setStarredFilter, setAllFilter, setGroupFilter, setTalkgroupFilter, setUnitFilter, setFilterRows, setFilterTimeframe } = callPlayerSlice.actions

export default callPlayerSlice.reducer



